export interface ITopicsState {
  isError: boolean;
  list: Array<{
    id: number;
    contentId?: string;
    contentIdType?: string;
    url: string;
    title: string;
    hasVideo: boolean;
    isNew: boolean;
    isLive: boolean;
    useThumbnail: boolean;
    imageUrl: string;
    videoDuration?: string;
    testId?: number;
    articleIsOriginal: boolean;
  }>;
}
const initialState: ITopicsState = {
  isError: true,
  list: []
};
export default (state: ITopicsState = initialState) => {
  return state;
};
